import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  modalTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'end',
  },
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      '& .makeStyles-dialogTitle-37': {
        padding: '16px 12px !important',
      },
      maxWidth: '2250px'
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  headerCell: {
    border: '2px solid white',
    backgroundColor: '#cccccc',
    color: 'black',
    fontWeight: 'bold',
    padding: '4px',
    height: '20px'
  },
  rowCell: {
    border: '2px solid white',
    backgroundColor: '#e0e0e0',
    color: 'black',
    padding: '4px',
    height: '20px'
  },
  tableContainer: {
    maxWidth: 300,
    height: 'auto',
    maxHeight: 600
  },
  dialogTitle: {
    lineHeight: '2 !important',
    padding: '8px 10px !important',
  },
  menuTogglerBtn: {
    position: 'absolute',
    bottom: '23vh',
    zIndex: 2000,
    right: '-20px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  menuTogglerTableBtn: {
    position: 'absolute',
    bottom: '23vh',
    zIndex: 2000,
    right: '40.70%',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  titleHeader: {
    fontWeight: 'bold',
    fontSize: '18px'
  },
  boxStyle: {
    overflow: 'auto',
    marginTop: '-2%'
  },
  iconSize: {
    fontSize: '33px'
  },
  progressBarStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '700px'
  }
}));
export default styles;
